var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$vuetify.breakpoint.smAndDown)?_c('ItemMobile'):_c('ItemDesktop')}
var staticRenderFns = []

export { render, staticRenderFns }